import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import type { DemoPersona } from './demo-persona';

@Component({
  selector: 'noxo-demo-persona-list',
  template: `
    @for (persona of personas(); track persona.email) {
      <button
        type="button"
        [class.active]="signedInAs() === persona.email"
        [attr.aria-pressed]="signedInAs() === persona.email"
        [disabled]="busy()"
        [title]="persona.caption + ' · ' + persona.email"
        (click)="picked.emit(persona)">
        {{ persona.label }}
      </button>
    }
  `,
  styleUrl: './demo-persona-list.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoPersonaList {
  public readonly personas = input.required<readonly DemoPersona[]>();
  public readonly signedInAs = input('');
  public readonly busy = input(false);
  public readonly picked = output<DemoPersona>();
}
